export default "__VITE_ASSET__CXexhstS__"